import { z } from 'zod';
export const ApprovalEventTypeSchema = z.enum([
    'CREATED',
    'SUBMITTED',
    'RESUBMITTED',
    'REVIEWED',
    'APPROVED',
    'REJECTED',
    'RETURNED',
    'EDITED',
    'POSTED',
    'PAID',
    'CANCELLED',
    'DELETED',
    'REVERSED',
]);
export const ApprovalEventSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    docType: z.string().min(1),
    docId: z.uuid(),
    voucherNo: z.string().nullable().optional(),
    eventType: ApprovalEventTypeSchema,
    stepNo: z.number().int().positive().nullable().optional(),
    roleCode: z.string().nullable().optional(),
    roleLabel: z.string().nullable().optional(),
    fromStatus: z.string().nullable().optional(),
    toStatus: z.string().nullable().optional(),
    actorId: z.uuid().nullable().optional(),
    actorName: z.string(),
    reason: z.string().nullable().optional(),
    detail: z.record(z.string(), z.unknown()).nullable().optional(),
    createdAt: z.coerce.date(),
});
//# sourceMappingURL=approval-event.js.map